@import '../table/pageWithTable.module.scss';

.container {
  > .header {
    margin-top: 0;
  }
}
